jQuery(document).ready(function ($) {
  /**
   *--------------------------------------------------------------------------
   * Scroll to top link
   *--------------------------------------------------------------------------
   */
  // Check to see if the window is top if not then display button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('.js-scroll-to-top').fadeIn();
    } else {
      $('.js-scroll-to-top').fadeOut();
    }
  });
  // Change focus to the top most link, in this case Skip to content
  $('.js-scroll-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 800);
    return false;
  });
});
